import styled from 'styled-components';
import { InputLabel, InputLabelProps } from '@mui/material';
import { componentToken } from '../../style/utils';

export const SelectInputLabel = styled(InputLabel)<{
  $size?: 'small' | 'medium';
}>`
  background: ${({ disabled, theme }) =>
    disabled
      ? 'transparent !important'
      : theme.tokens.components.dropDown.label.background};

  &.MuiInputLabel-root {
    top: ${({ $size }) => ($size === 'medium' ? '-6px' : '-11px')};
  }
  &.MuiInputLabel-shrink {
    font-size: ${({ $size }) =>
      $size === 'small'
        ? componentToken('dropDown.label.shrinkFontSize')
        : undefined};
    top: ${({ $size }) => ($size === 'small' ? '1px' : 0)};
    padding: ${componentToken('dropDown.label.shrinkPadding')};
  }
`;

type Props = Omit<InputLabelProps, 'size'> & {
  size?: 'small' | 'medium';
};

const DropDownInputLabel = ({ size, ...props }: Props) => (
  <SelectInputLabel $size={size} {...props} />
);

DropDownInputLabel.defaultProps = {
  size: 'medium',
};

export default DropDownInputLabel;
